import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ParsableDate } from "@material-ui/pickers/constants/prop-types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import "date-fns";

export default function MonthPicker({
  value,
  handleChange,
}: {
  value: ParsableDate;
  handleChange: (date: Date, value?: string | null | undefined) => void;
}) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        variant="inline"
        inputVariant="outlined"
        openTo="year"
        views={["year", "month"]}
        label="Year and Month"
        helperText="Start from year selection"
        value={value}
        onChange={handleChange as (date: MaterialUiPickersDate, value?: string | null | undefined) => void}
      />
    </MuiPickersUtilsProvider>
  );
}
